import { requiredErrorMessage } from '@common/schema';
import * as yup from 'yup';
import { MAXIMUM_STRING_LENGTH } from '@common/types/constants.ts';

export const detailsModalSchema = yup
  .object({
    report_type: yup.string().required(requiredErrorMessage),
    name: yup
      .string()
      .required(requiredErrorMessage)
      .max(
        MAXIMUM_STRING_LENGTH,
        `Name must be at most ${MAXIMUM_STRING_LENGTH} characters`,
      ),
    report_folder_id: yup.string().required(requiredErrorMessage),
    description: yup
      .string()
      .nullable()
      .default('')
      .max(
        400,
        'This input must be 400 characters or less. Please reduce the length to proceed.',
      ),
    private: yup.boolean().default(false),
    allow_others_to_edit: yup.boolean().default(false),
  })
  .required();
